'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Error$PvpcontrollerWeb = require("./Error.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Prompt$PvpcontrollerWeb = require("./Prompt.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var EditModeService$PvpcontrollerWeb = require("../services/EditModeService.js");
var EditModeChangelog$PvpcontrollerWeb = require("./EditModeChangelog.js");

Curry._2(Css.$$global, "table", {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: {
        hd: Css.borderCollapse("collapse"),
        tl: /* [] */0
      }
    });

var button = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(16)),
      tl: {
        hd: Css.border("zero", "solid", Css.transparent),
        tl: {
          hd: Css.backgroundColor(Css.hex("26282b")),
          tl: {
            hd: Css.padding(Css.px(10)),
            tl: {
              hd: Css.color(Css.hex("abb6c7")),
              tl: {
                hd: Css.borderRadius(Css.px(5)),
                tl: {
                  hd: Css.cursor(Css.pointer),
                  tl: {
                    hd: Css.marginTop(Css.px(30)),
                    tl: {
                      hd: Css.marginRight(Css.px(20)),
                      tl: {
                        hd: Css.child("i")({
                              hd: Css.marginRight(Css.px(10)),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

function detectEditModeReversion(setState, setPromptState, editMode) {
  var ref = React.useRef(undefined);
  React.useEffect(function () {
        var match = ref.current;
        if (editMode !== 1 || match !== 0) {
          
        } else {
          Curry._1(setState, (function (_previousState) {
                  return /* Loading */0;
                }));
          Curry._1(setPromptState, (function (_previousState) {
                  return /* Show */0;
                }));
        }
        ref.current = editMode;
        
      });
  
}

function EditModeReview(Props) {
  var session = Props.session;
  var setEditMode = Props.setEditMode;
  var editMode = Props.editMode;
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return /* Hide */1;
      });
  var setPromptState = match$1[1];
  React.useEffect((function () {
          if (typeof state === "number") {
            if (state !== /* Loading */0) {
              return ;
            }
            
          } else {
            switch (state.TAG | 0) {
              case /* StealthLoading */0 :
                  break;
              case /* Changes */1 :
                  return ;
              case /* DoPublishChanges */2 :
                  return EditModeService$PvpcontrollerWeb.publishEditModeChangelog(session, state._0, (function (result) {
                                if (result.TAG !== /* Ok */0) {
                                  return Curry._1(setState, (function (_previousState) {
                                                return /* LoadingFailed */1;
                                              }));
                                }
                                var match = result._0.status;
                                if (match === 200) {
                                  return Curry._1(setState, (function (_previousState) {
                                                return /* Loading */0;
                                              }));
                                }
                                match !== 409;
                                Curry._1(setState, (function (_previousState) {
                                        return /* Loading */0;
                                      }));
                                return Curry._1(setPromptState, (function (_previousState) {
                                              return /* Show */0;
                                            }));
                              }));
              case /* DoRollbackChanges */3 :
                  return EditModeService$PvpcontrollerWeb.rollbackEditModeChangelog(session, state._0, (function (result) {
                                if (result.TAG !== /* Ok */0) {
                                  return Curry._1(setState, (function (_previousState) {
                                                return /* LoadingFailed */1;
                                              }));
                                }
                                var match = result._0.status;
                                if (match === 200) {
                                  return Curry._1(setState, (function (_previousState) {
                                                return /* Loading */0;
                                              }));
                                }
                                match !== 409;
                                Curry._1(setState, (function (_previousState) {
                                        return /* Loading */0;
                                      }));
                                return Curry._1(setPromptState, (function (_previousState) {
                                              return /* Show */0;
                                            }));
                              }));
              
            }
          }
          return EditModeService$PvpcontrollerWeb.getEditModeChangelog(session, (function (changes) {
                        if (changes.TAG === /* Ok */0) {
                          var changes$1 = changes._0;
                          return Curry._1(setState, (function (_previousState) {
                                        return {
                                                TAG: /* Changes */1,
                                                _0: changes$1
                                              };
                                      }));
                        }
                        var err = changes._0;
                        if (err.RE_EXN_ID === "Match_failure") {
                          var match = err._1;
                          Debugging$PvpcontrollerWeb.messageWithData("EditModeReview-PvpcontrollerWeb" + (":getEditModeChangelog Could not destructure change. Failed at " + match[0] + ":L" + match[1].toString() + "_C" + match[2].toString()), {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        } else {
                          Debugging$PvpcontrollerWeb.messageWithData("EditModeReview-PvpcontrollerWeb:getEditModeChangelog Could not get changes.", {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        }
                        return Curry._1(setState, (function (_previousState) {
                                      return /* LoadingFailed */1;
                                    }));
                      }));
        }), [state]);
  detectEditModeReversion(setState, setPromptState, editMode);
  var tmp;
  var exit = 0;
  var exit$1 = 0;
  var exit$2 = 0;
  if (typeof state === "number") {
    if (state === /* LoadingFailed */1) {
      exit = 1;
    } else {
      exit$2 = 4;
    }
  } else {
    switch (state.TAG | 0) {
      case /* StealthLoading */0 :
          switch (editMode) {
            case /* Unknown */0 :
                exit$2 = 4;
                break;
            case /* Enabled */1 :
                exit$1 = 3;
                break;
            case /* Disabled */2 :
                exit = 1;
                break;
            
          }
          break;
      case /* Changes */1 :
          switch (editMode) {
            case /* Unknown */0 :
                exit$2 = 4;
                break;
            case /* Enabled */1 :
                exit$1 = 3;
                break;
            case /* Disabled */2 :
                exit = 1;
                break;
            
          }
          break;
      default:
        exit$2 = 4;
    }
  }
  if (exit$2 === 4) {
    if (editMode !== 0) {
      exit$1 = 3;
    } else {
      exit = 2;
    }
  }
  if (exit$1 === 3) {
    var exit$3 = 0;
    if (typeof state === "number") {
      exit = 2;
    } else {
      switch (state.TAG | 0) {
        case /* StealthLoading */0 :
        case /* Changes */1 :
            exit$3 = 4;
            break;
        default:
          exit = 2;
      }
    }
    if (exit$3 === 4) {
      var changes = state._0;
      var tmp$1;
      if (changes.length > 0) {
        if (typeof state === "number") {
          tmp$1 = React.createElement(React.Fragment, undefined);
        } else {
          switch (state.TAG | 0) {
            case /* StealthLoading */0 :
                tmp$1 = React.createElement(React.Fragment, undefined);
                break;
            case /* Changes */1 :
                tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("button", {
                          className: button,
                          onClick: (function (param) {
                              return Curry._1(setState, (function (previousState) {
                                            if (typeof previousState === "number" || previousState.TAG === /* StealthLoading */0) {
                                              return previousState;
                                            } else {
                                              return {
                                                      TAG: /* DoPublishChanges */2,
                                                      _0: previousState._0
                                                    };
                                            }
                                          }));
                            })
                        }, React.createElement("i", {
                              className: "fas fa-upload"
                            }), "Publish Changes"), React.createElement("button", {
                          className: button,
                          onClick: (function (param) {
                              return Curry._1(setState, (function (previousState) {
                                            if (typeof previousState === "number" || previousState.TAG === /* StealthLoading */0) {
                                              return previousState;
                                            } else {
                                              return {
                                                      TAG: /* DoRollbackChanges */3,
                                                      _0: previousState._0
                                                    };
                                            }
                                          }));
                            })
                        }, React.createElement("i", {
                              className: "fas fa-undo"
                            }), "Rollback Changes"));
                break;
            default:
              tmp$1 = React.createElement(React.Fragment, undefined);
          }
        }
      } else {
        tmp$1 = React.createElement("button", {
              className: button,
              onClick: (function (param) {
                  return Curry._1(setEditMode, (function (_previousState) {
                                return /* Disabled */2;
                              }));
                })
            }, "Exit Edit Mode");
      }
      tmp = React.createElement(React.Fragment, undefined, React.createElement(EditModeChangelog$PvpcontrollerWeb.make, EditModeChangelog$PvpcontrollerWeb.makeProps(session, changes, undefined, (function (param) {
                      return Curry._1(setState, (function (_previousState) {
                                    return {
                                            TAG: /* StealthLoading */0,
                                            _0: changes
                                          };
                                  }));
                    }), (function (param) {
                      Curry._1(setPromptState, (function (_previousState) {
                              return /* Show */0;
                            }));
                      return Curry._1(setState, (function (_previousState) {
                                    return /* Loading */0;
                                  }));
                    }), undefined, undefined)), tmp$1);
    }
    
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement(Error$PvpcontrollerWeb.make, Error$PvpcontrollerWeb.makeProps(undefined, undefined));
        break;
    case 2 :
        tmp = React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
        break;
    
  }
  return React.createElement("div", undefined, match$1[0] ? React.createElement(React.Fragment, undefined) : React.createElement(Prompt$PvpcontrollerWeb.make, Prompt$PvpcontrollerWeb.makeProps("Edit Mode Desync", (function (_event) {
                          return Curry._1(setPromptState, (function (_previousState) {
                                        return /* Hide */1;
                                      }));
                        }), "Your client was not syncronised with the latest changes. You will need to review them and decide if you still want to take the same action.", undefined, undefined)), React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Changes from Edit Mode"), tmp);
}

function makeProps(prim0, prim1, prim2, prim3, prim4) {
  var tmp = {
    session: prim0,
    setEditMode: prim1,
    editMode: prim2
  };
  if (prim3 !== undefined) {
    tmp.key = prim3;
  }
  return tmp;
}

var make = EditModeReview;

exports.makeProps = makeProps;
exports.make = make;
/*  Not a pure module */
